import { useFormContext } from 'react-hook-form';
import { msg, optionalEmailSchema } from '~/utils/validation';
import { z } from 'zod';

export const schema = z.object({
  permissions: z
    .object({
      federation_admin: z.boolean().optional(),
      judge_admin: z.boolean().optional(),
    })
    .optional(),
  email: optionalEmailSchema,
  username: z.string().min(1, { message: msg.required }),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
});

export const useCreateUserForm = useFormContext<Schema>;

export type Schema = z.infer<typeof schema>;
